import React from 'react';
import { Card, CardContent } from './ui/card';
import { Star, Quote } from 'lucide-react';
import { mockData } from '../mock';

export const Testimonials = () => {
  return (
    <section id="testimonials" className="py-24 bg-gradient-to-br from-stone-50 via-emerald-50/20 to-stone-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-4xl md:text-5xl font-bold text-stone-900">
            Témoignages
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-emerald-600 to-emerald-400 mx-auto rounded-full" />
          <p className="text-lg text-stone-600 max-w-2xl mx-auto">
            La satisfaction de mes clients est ma priorité
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {mockData.testimonials.map((testimonial, index) => (
            <Card 
              key={testimonial.id}
              className="group hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border-stone-200 hover:border-emerald-300 bg-white relative overflow-hidden"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-emerald-100/50 to-transparent rounded-bl-full" />
              
              <CardContent className="p-8 space-y-6 relative">
                {/* Quote icon */}
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-emerald-100 to-emerald-50 flex items-center justify-center">
                  <Quote className="w-6 h-6 text-emerald-700" />
                </div>

                {/* Stars */}
                <div className="flex gap-1">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 fill-emerald-500 text-emerald-500" />
                  ))}
                </div>

                {/* Content */}
                <p className="text-stone-700 leading-relaxed italic">
                  "{testimonial.content}"
                </p>

                {/* Author */}
                <div className="pt-4 border-t border-stone-200">
                  <p className="font-bold text-stone-900">{testimonial.name}</p>
                  <p className="text-sm text-emerald-700">{testimonial.role}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};